import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getSelectTalleres } from 'services/servicioGet';
import { TipoGenerico } from 'utils/models/types';

interface TalleresSelectState {
  talleresSelect: TipoGenerico[];
  loadingTalleresSelect: boolean;
  errorTalleresSelect: string | null;
}

// Estado inicial del slice
const initialState: TalleresSelectState = {
  talleresSelect: [],
  loadingTalleresSelect: false,
  errorTalleresSelect: null,
};

// Thunk para obtener los talleres
export const fetchSelectTalleres = createAsyncThunk('talleres/fetchSelectTalleres', async (_, { rejectWithValue }) => {
  try {
    const response = await getSelectTalleres();
    return response;
  } catch (error: unknown) {
    return rejectWithValue(error instanceof Error ? error.message : String(error));
  }
});

// Slice de talleres
const talleresSelectSlice = createSlice({
  name: 'talleresSelect',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchSelectTalleres.pending, state => {
        state.loadingTalleresSelect = true;
        state.errorTalleresSelect = null;
      })
      .addCase(fetchSelectTalleres.fulfilled, (state, action) => {
        state.talleresSelect = action.payload;
        state.loadingTalleresSelect = false;
      })
      .addCase(fetchSelectTalleres.rejected, (state, action) => {
        state.loadingTalleresSelect = false;
        state.errorTalleresSelect = action.payload as string;
      });
  },
});

export default talleresSelectSlice.reducer;
